import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      fk: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Affiliate Service',
    field: 'productServiceId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'productServiceId',
      fk: 'productServiceId',
      namespace: 'productService',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
